import { Container } from "@mui/material";
import React, { useState } from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import HolidayCard from "./HolidayCard";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import HolidayTable from "./HolidayTable";
import dayjs from "dayjs";
import AssignHolidayDialog from "./AssignHolidayDialog";

const HolidayPage = () => {
  //#region
  const [isCreate, setIsCreate] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [holidayList, setHolidayList] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const { company_id } = useSelector((state) => state.GlobalVariables);

  const [searchTerm, setSearchTerm] = React.useState("");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [isEdit, setisEdit] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [editId, setEditId] = React.useState(null);
  //   console.log("searchTerm", searchTerm);
  //   console.log("dateRange", dateRange);

  const handlePopup = () => {
    try {
      setIsCreate(!isCreate);
      setisEdit(false);
      setEditData(null);
      setEditId(null);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchHolidayList = async (
    page = pagination.page,
    limit = pagination.limit
  ) => {
    setLoading(true);
    try {
      const payload = {
        page,
        limit,
        company_id,
        search: searchTerm || null,
        from_date: dateRange?.[0]
          ? dayjs(dateRange[0]).format("DD-MM-YYYY")
          : null,
        to_date: dateRange?.[1]
          ? dayjs(dateRange[1]).format("DD-MM-YYYY")
          : null,
      };

      const result = await configServ.getHolidays(payload);

      if (result.status) {
        setHolidayList(result.data);
        setPagination((prev) => ({
          ...prev,
          total: result.pagination.total_records,
          page: result.pagination.current_page,
          limit: result.pagination.per_page,
        }));
      }
    } catch (error) {
      console.log("Error fetching holiday list:", error);
      setHolidayList([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchHolidayList();
  }, [searchTerm, dateRange]);

  const onEdit = (row) => {
    setIsCreate(true);
    setEditData(row);
    setisEdit(true);
    setEditId(row.id);
  };

  const [openAssign, setOpenAssign] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [batchList, setBatchList] = useState([]);

  const onAssing = (row) => {
    setSelectedHoliday(row.id); // holiday_id milega
    setOpenAssign(true);
  };

  const fetchBatchList = async () => {
    try {
      const result = await configServ.getActiveBatches({ company_id });
      if (result.status) {
        setBatchList(result.data);
      } else {
        setBatchList([]);
      }
    } catch (error) {
      console.log("Error fetching batch list", error);
      setBatchList([]);
    }
  };

  React.useEffect(() => {
    if (openAssign) {
      fetchBatchList();
    }
  }, [openAssign]);

  //#endregion
  return (
    <>
      <AssignHolidayDialog
        open={openAssign}
        onClose={() => setOpenAssign(false)}
        holiday={selectedHoliday}
        batchList={batchList} // backend se aayi hui batches
      />

      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"Holiday List"}
          handlePopup={handlePopup}
          //   isEdit={isEdit}
          create={isCreate}
        />
      </Container>
      {isCreate && (
        <HolidayCard
          isEdit={isEdit}
          editData={editData}
          fetchHolidayList={fetchHolidayList}
          handlePopup={handlePopup}
          editId={editId}
          setEditId={setEditId}
          setEditData={setEditData}
          setisEdit={setisEdit}
        />
      )}

      <HolidayTable
        holidayList={holidayList}
        loading={loading}
        pagination={pagination}
        onPageChange={(page, limit) => fetchHolidayList(page, limit)}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dateRange={dateRange}
        setDateRange={setDateRange}
        onEdit={onEdit}
        onAssing={onAssing}
      />
    </>
  );
};

export default HolidayPage;
